import { useCallback } from 'react';
import { useAlert } from '../contexts';
import { logError, logWarning } from '../utils/errorLogger';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export const useNotification = () => {
  const { showAlert } = useAlert();

  const showNotification = useCallback(
    async (message: string, type: NotificationType = 'info', duration: number = 5000) => {
      // Map NotificationType to AlertType
      const alertType = type as 'success' | 'error' | 'warning' | 'info';
      
      // Determine title based on type
      const title = type === 'error' 
        ? 'Error' 
        : type === 'success' 
        ? 'Success' 
        : type === 'warning' 
        ? 'Warning' 
        : 'Information';

      // Log using proper logging utilities
      if (type === 'error') {
        logError(message);
      } else if (type === 'warning') {
        logWarning(message);
      }

      // Show alert using the unified alert system
      await showAlert(message, alertType, title);
    },
    [showAlert]
  );

  return { showNotification };
};

export default useNotification;
